import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import {
  LoanOperPostParams,
  LoanSearchParams,
  LoanSearchServerData,
  LoanViewParams,
  LoanViewServerData,
  UpdateCommentsParams,
  AddNoteParams,
  EditNoteParams,
  DeleteNoteParams,
  AddEditMonitoringParams,
  DeleteMonitoringParams,
  UpdateCustomFieldsParams,
  LoanOperPostPages,
  LoanCoverParams,
  LoanCoverServerData,
  LoanAddParams,
  LoanAddServerData,
  LoanScheduleParams,
  LoanScheduleServerData,
  LoanOperParams,
  LoanRestRShortParams,
  LoanRestRServerData,
  LoanOperPages,
  LoanOperServerData,
} from './loan.types'

export class LoanProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  public loanSearch(params: LoanSearchParams): Promise<HttpServiceResponse<LoanSearchServerData>> {
    const query = qs.stringify(params)

    return this.http.post(`${this.baseUrl}/loan_search_api.php?${query}`)
  }

  public loanView(params: LoanViewParams): Promise<HttpServiceResponse<LoanViewServerData>> {
    const query = qs.stringify(params)

    return this.http.post(`${this.baseUrl}/loan_view_api.php?${query}`)
  }

  private loanOperPost(params: LoanOperPostParams): Promise<HttpServiceResponse<void>> {
    const { LoanID, HashSum_LoanID_, page, ...body } = params

    const query = qs.stringify({
      LoanID,
      HashSum_LoanID_,
      page,
    })

    return this.http.post(`${this.baseUrl}/loan_oper_post_api.php?${query}`, body)
  }

  public loanOper(params: LoanOperParams): Promise<HttpServiceResponse<LoanOperServerData>> {
    //@ts-ignore
    const { page, ...body } = params

    const query = qs.stringify({
      page,
    })

    return this.http.post(`${this.baseUrl}/loan_oper_api.php?${query}`, body)
  }

  public loanRestRShort(params: LoanRestRShortParams): Promise<HttpServiceResponse<LoanRestRServerData>> {
    return this.loanOper({ ...params, page: LoanOperPages.RESTRSHORT })
  }

  public updateComments(params: UpdateCommentsParams): Promise<HttpServiceResponse<void>> {
    return this.loanOperPost({ ...params, page: LoanOperPostPages.COMMENTS })
  }

  public addNote(params: AddNoteParams): Promise<HttpServiceResponse<void>> {
    return this.loanOperPost({ ...params, page: LoanOperPostPages.NOTEADD })
  }

  public editNote(params: EditNoteParams): Promise<HttpServiceResponse<void>> {
    return this.loanOperPost({ ...params, page: LoanOperPostPages.NOTEEDIT })
  }

  public deleteNote(params: DeleteNoteParams): Promise<HttpServiceResponse<void>> {
    return this.loanOperPost({ ...params, page: LoanOperPostPages.NOTEDELETE })
  }

  public addEditMonitoring(params: AddEditMonitoringParams): Promise<HttpServiceResponse<void>> {
    return this.loanOperPost({
      ...params,
      page: params.ID ? LoanOperPostPages.MONITORINGEDIT : LoanOperPostPages.MONITORINGADD,
    })
  }

  public deleteMonitoring(params: DeleteMonitoringParams): Promise<HttpServiceResponse<void>> {
    return this.loanOperPost({ ...params, page: LoanOperPostPages.MONITORINGDELETE })
  }

  public updateCustomFields(params: UpdateCustomFieldsParams): Promise<HttpServiceResponse<void>> {
    return this.loanOperPost({ ...params, page: LoanOperPostPages.CUSTFIELDSUPDATE })
  }

  public loanCover({ action, ...params }: LoanCoverParams): Promise<HttpServiceResponse<LoanCoverServerData>> {
    const query = qs.stringify({ action })
    const body = {
      ...params,
    }

    return this.http.post(`${this.baseUrl}/loan_cover_api.php?${query}`, body)
  }

  public loanAdd(params: LoanAddParams): Promise<HttpServiceResponse<LoanAddServerData>> {
    const { action, ...body } = params

    const query = qs.stringify({ action })

    return this.http.post(`${this.baseUrl}/loan_add_api.php?${query}`, body)
  }

  public loanSchedule(params: LoanScheduleParams): Promise<HttpServiceResponse<LoanScheduleServerData>> {
    const query = qs.stringify(params)

    return this.http.post(`${this.baseUrl}/loan_schedule_api.php?${query}`)
  }
}
